import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  viewMode, 
  onViewModeChange, 
  onNavigate,
  onTodayClick 
}) => {
  const formatHeaderDate = () => {
    const options = { 
      year: 'numeric', 
      month: 'long',
      ...(viewMode === 'week' && { day: 'numeric' })
    };
    return currentDate?.toLocaleDateString('fr-FR', options);
  };

  const viewModes = [
    { key: 'month', label: 'Mois', icon: 'Calendar' },
    { key: 'week', label: 'Semaine', icon: 'CalendarDays' },
    { key: 'agenda', label: 'Agenda', icon: 'List' }
  ];

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
      <div className="flex items-center space-x-4">
        <h1 className="text-2xl font-heading font-bold text-foreground">
          Calendrier des Admissions
        </h1>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronLeft"
            onClick={() => onNavigate('prev')}
            className="w-10 h-10"
          />
          <div className="px-4 py-2 bg-muted rounded-lg">
            <span className="font-medium text-foreground capitalize">
              {formatHeaderDate()}
            </span>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronRight"
            onClick={() => onNavigate('next')}
            className="w-10 h-10"
          />
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <Button
          variant="outline"
          size="sm"
          iconName="Calendar"
          onClick={onTodayClick}
        >
          Aujourd'hui
        </Button>
        
        <div className="flex bg-muted rounded-lg p-1">
          {viewModes?.map((mode) => (
            <button
              key={mode?.key}
              onClick={() => onViewModeChange(mode?.key)}
              className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-smooth ${
                viewMode === mode?.key
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-background'
              }`}
            >
              <Icon name={mode?.icon} size={16} />
              <span className="hidden sm:inline">{mode?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;